<template>
  <section class="footer">
    <div class="container">
      <div class="footer-head">
        <div class="logo">
          <svgLogoWhite />
        </div>
        <hr />
        <div class="actions">
          <button>
            <svgMail v-on:click="sendMailTo" />
          </button>
          <button v-on:click="openOCS">
            <svgHome />
          </button>
        </div>
      </div>
      <div class="footer-body">
        <div class="r">오지큐 주식회사ㅣ대표이사 신철호 ㅣ 서울특별시 강남구 논현로 164 10층 (도곡동, 튼튼영어빌딩)</div>
        <div class="r">사업자 등록번호 220-86-76113 ㅣ 통신판매업신고번호 제2018-서울강남-03954호 ㅣ 이메일 cp.help@ogqcorp.com</div>
      </div>
    </div>
  </section>
</template>

<script>
import svgLogoWhite from '@/svg/svgLogoWhite'
import svgMail from '@/svg/svgMail'
import svgHome from '@/svg/svgHome'

export default {
  methods: {
    openOCS() {
      return window.open('https://creators.ogq.me/', '_blank')
    },
    sendMailTo() {
      const a = document.createElement('a')
      a.href = "mailto:cp.help@ogqcorp.com"
      a.click()
      a.parentNode.removeChild(a)
    }
  },
  components: {
    svgLogoWhite,
    svgHome,
    svgMail
  }
}
</script>

<style lang="scss" scoped>
section.footer {
  padding: 36px 0;
  background-color: black;
}

.footer-head {
  display: flex;
  align-items: center;
}

.footer-head svg {
  display: block;
  width: auto;
  height: 19px;
  margin-right: 25px
}

.actions {
  display: flex;
  margin-left: 20px;
  margin-right: -4px;
}

.actions button {
  padding: 4px;
  border: 0;
  outline: 0;
  background: transparent;
  width: 24px;
  height: 24px;
  display: flex;
  svg {
    display: block;
    width: 12px;
    margin: auto;
  }
}

.footer-head hr {
  flex: 1;
  background-color: #353535;
  color: #353535;
  height: 1px;
  box-shadow: 0;
  border: 0;
}

.footer-body {
  margin-top: 25px;
}

.r {
  font-size: 11px;
  line-height: 18px;
  font-weight: 400;
  color: #767877;
  @media screen and (max-width: 600px) {
    display: inline;
    &:after {
      content: ' ';
    }
  }
}
</style>